import { render } from "./appheader.vue?vue&type=template&id=72d0af74"
import script from "./appheader.vue?vue&type=script&lang=js"
export * from "./appheader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__